import * as React from "react";

export type BadgeProps = React.HTMLAttributes<HTMLSpanElement> & {
  variant?: "default" | "secondary" | "success" | "warning" | "danger";
  size?: "sm" | "md";
};

export function Badge({ className = "", variant = "default", size = "md", ...props }: BadgeProps) {
  const baseSize = size === "sm" ? "px-1 py-0 text-[9px]" : "px-2 py-0.5 text-xs";
  const base = `inline-flex items-center rounded-full font-medium ${baseSize}`;
  const styles =
    variant === "secondary"
      ? "bg-neutral-100 text-neutral-800 border border-neutral-200"
      : variant === "success"
      ? "bg-green-100 text-green-800 border border-green-200"
      : variant === "warning"
      ? "bg-yellow-100 text-yellow-800 border border-yellow-200"
      : variant === "danger"
      ? "bg-red-100 text-red-800 border border-red-200"
      : "bg-neutral-900 text-white";
  return <span className={`${base} ${styles} ${className}`} {...props} />;
}

export default Badge;

